const ADMIN_ACCESS_ERROR = 'admin_access_denied';

export function buildAdminGoogleLoginUrl({
  processorApi = process.env.REACT_APP_PROCESSOR_API,
  origin = window.location.origin,
} = {}) {
  const normalizedProcessorApi =
    typeof processorApi === 'string' ? processorApi.trim().replace(/\/+$/, '') : '';
  if (!normalizedProcessorApi || !origin) {
    return '';
  }

  const params = new URLSearchParams({
    adminLogin: 'true',
    cookieConsent: 'rejected',
    origin,
    responseMode: 'redirect',
  });

  return `${normalizedProcessorApi}/users/google_login?${params.toString()}`;
}

export function consumeAdminGoogleLoginCallback({
  location = window.location,
  history = window.history,
} = {}) {
  const params = new URLSearchParams(location.search || '');
  const authToken = params.get('authToken')?.trim() || '';
  const errorCode = params.get('googleLoginError')?.trim() || '';

  if (authToken || errorCode) {
    params.delete('authToken');
    params.delete('googleLoginError');
    params.delete('newUser');

    const pathname = location.pathname === '/verify' ? '/' : location.pathname;
    const nextSearch = params.toString();
    history.replaceState(
      {},
      document.title,
      `${pathname}${nextSearch ? `?${nextSearch}` : ''}${location.hash || ''}`,
    );
  }

  return {
    authToken,
    error:
      errorCode === ADMIN_ACCESS_ERROR
        ? 'This Google account does not have administrator privileges.'
        : errorCode
          ? 'Google sign-in was not completed. Please try again.'
          : '',
  };
}
